// extracted by mini-css-extract-plugin
module.exports = {"trending_slider":"bOk1Z","sliderHeading":"GOG94","sliderItemHeading":"eboVR","trending_sliderContent":"L5f4Q","trending_slider_ani":"v6JNn"};